import React, { Fragment } from 'react'
import Router, { withRouter } from 'next/router'
import styled from 'styled-components'
import getConfig from 'next/config'
import Input from '../Input'
import GlobalContext from '../GlobalContext'
import RadioSelected from '../icons/RadioSelected'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import Text from '../Text'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { CheckoutAddressConsumer } from '../../components/CheckoutAddressProvider'
import addressSearch from '../../lib/addressSearch'
import { stripCountryCode } from './../../utils/formatUtils'
import { SCREEN_SIZE } from '../../lib/Media'
import { get } from '../../lib/fetch'
import deepEqual from 'fast-deep-equal'
import BulbImg from '../../static/BulbImage/image.png'
import BulbImg2X from '../../static/BulbImage/image@2x.png'
import BulbImg3X from '../../static/BulbImage/image@3x.png'
import { boysBrigadeConfigFn } from '../../utils/boysBrigadeUtils'
import { getUserType } from '../../utils/userType'

const {
  publicRuntimeConfig: { API_URL, PUBLIC_API_URL },
} = getConfig()

const StyledLocationSearch = styled.div`
  margin-top: 0;
  .autocomplete-dropdown-container {
    display: block;
    overflow: hidden;
    margin-top: 1rem;
  }

  .autocomplete-dropdown-container .suggestion-item {
    padding: 0.6rem 0.45rem;
    background-color: #ffffff;
    line-height: 1.25rem;
    font-size: 0.75rem;
    color: #696969;
    cursor: pointer;
    &:not(:last-child) {
      border-bottom: 0.0625rem solid #eaeaea;
    }
  }

  .autocomplete-dropdown-container .suggestion-item.active {
    background-color: #f8f8f8;
  }

  .autocomplete-dropdown-container .suggestion-item .main-text {
    font-size: 0.9rem;
    font-weight: 600;
    color: #333333;
    display: block;
  }

  > .autocomplete-dropdown-container .loader {
    margin: 1.25rem auto 0.65rem;
  }
`
const ErrorText = styled.div`
  color: #dd0d42;
  font-size: 0.8rem;
  margin: 0.5rem 0 0.5rem 0.875rem;
`

const ArrowWrap = styled.div`
  margin-left: auto;
  i {
    border: solid #333333;
    border-width: 0 0.125rem 0.125rem 0;
    display: inline-block;
    padding: 0.1875rem;
    transform: rotate(-45deg);
    margin: auto;
  }
`
const TitleContent = styled.div`
  position: absolute;
  top: 0;
  text-align: center;
  left: 0;
  padding: 0.75rem;
  right: 0;
  color: #333;
  font-weight: bold;
  line-height: 1.5;
  border-bottom: solid 0.0625rem #eaeaea;
`

const NoResult = styled.div`
  text-align: center;
  font-size: 0.9rem;
  color: #696969;
  margin-bottom: 0.5rem;
`

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`

const InputWrp = styled.div`
  input {
    padding-right: 2rem;
  }
`

const Button = styled.button`
  border: none;
  outline: none;
  border-radius: 1.75rem;
  display: block;
  cursor: pointer;

  max-width: 17.5rem;
  width: 100%;
  height: 3.5rem;
  padding: 1rem 1.5rem;
  background-color: #1557bf;
  margin: 1.5rem auto 0 auto;
`

const AddressCardWrp = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

const AddressCard = styled.div`
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
  border: solid 0.0625rem #eaeaea;
  background-color: #ffffff;
  cursor: pointer;
  overflow: hidden;
`

const CardTitle = styled.div`
  display: flex;
`

const RadioSelectedIcon = styled(RadioSelected)`
  margin-left: auto;
  height: 1rem;
  width: 1rem;
`

const WrpText = styled(Text)`
  margin: ${props => props.margin || 'unset'};
`

const BulbIcon = styled.img`
  display: inline-block;
  height: 1rem;
  position: absolute;
  left: 0.625rem;
  top: 0.625rem;
`

const Results = styled.div`
  max-height: calc(100vh - 22rem);
  position: relative;
  overflow-y: auto;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  ${SCREEN_SIZE.From.Tablet} {
    max-height: calc(100vh - 25.5rem);
  }
`

const HelpText = styled(Text)`
  position: relative;
  cursor: pointer;
  display: flex;
  padding: 0.5rem;
  background-color: #fff0e5;
  margin-top: 0.5rem;
  border-radius: 0.25rem;
  > p {
    padding-left: 1.25rem;
    display: inline-block;
    color: #333;
    > strong {
      font-weight: bold;
    }
  }
`
const LocationText = styled(Text)`
  cursor: pointer;
  color: #1557bf;
  padding-left: 0.875rem;
`
const WrappperDiv = styled.div`
  padding: ${props => (props.padEnable ? '1rem' : '2.5rem 0 0 0')};
`

class LocationSearch extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSetAddress = this.handleSetAddress.bind(this)
    this.clearText = this.clearText.bind(this)
    this.handleGetCurrentLocation = this.handleGetCurrentLocation.bind(this)
    this.handleSetDeliveryAddress = this.handleSetDeliveryAddress.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.processChangeStore = this.processChangeStore.bind(this)
    this.sendTrackingInfo = this.sendTrackingInfo.bind(this)
    this.handleDonate = this.handleDonate.bind(this)
    this.handleClickAndCollect = this.handleClickAndCollect.bind(this)
    const clickAndCollectValue =
    { "title": "See stores with Click & Collect service", "prefilledText": "Collect from", "enabled":false }
    const boysBrigadeValue = boysBrigadeConfigFn()
    const isHintUrl = props?.router?.asPath?.includes('/pcm?hintPos')
    let preFillText = ''
    if (isHintUrl) {
      const pcmHints = ["donation"]
      const queryParam = props?.router?.query?.hintPos
      const isDonation = pcmHints[queryParam] === 'donation'
      const isCnC = pcmHints[queryParam] === 'cnc'
      if (isDonation) {
        preFillText = boysBrigadeValue.prefilledText
      } else {
        if (isCnC) {
          preFillText = clickAndCollectValue.prefilledText
        }
      }
      if (isDonation || isCnC) {
        this.fetchAddressNStore(preFillText, isDonation)
      }
    }
    this.state = {
      term: preFillText,
      editing: isHintUrl,
      hideBackground: props.hideBackground || false,
      type: '',
      currentLocation: {
        ...(this.props.currentLocation &&
          this.props.currentLocation.location && {
            lat: this.props.currentLocation.location.latitude,
          }),
        ...(this.props.currentLocation &&
          this.props.currentLocation.location && {
            lng: this.props.currentLocation.location.longitude,
          }),
      },
      suggestions: [],
      isAddressSet: false, // set to identify if address/search api should be called
      isChangingStore: false,
      isClickOnPFCOrFFS: false, //to determine if click on PFC or FFS box in store selector
      isHintUrl,
      clickAndCollectValue,
      boysBrigadeValue,
    }
  }

  handleFocus() {
    this.setState({ editing: true })
  }

  processChangeStore(isChoseStorePFC, isCurrentStorePFC) {
    this.setState(
      {
        isClickOnPFCOrFFS: true,
      },
      () => {
        const newStoreType = isChoseStorePFC ? 'PFC' : 'FFS'
        const { onHandleClose, checkoutAddress, update } = this.props
        const newStoreClientId =
          checkoutAddress.availableStores?.find(
            i => i.storeType === newStoreType
          ).clientId || undefined

        this.sendTrackingInfo(`Label=StoreSelector-${newStoreType}`, true)
        if (isChoseStorePFC === isCurrentStorePFC) {
          onHandleClose()
        } else {
          const destinationStore = checkoutAddress.availableStores.filter(
            function(store) {
              return store.storeType === newStoreType
            }
          )
          if (destinationStore.length) {
            const { id, name } = destinationStore[0]
            const storeinfo = {
              ...checkoutAddress,
              storeId: id,
              storeName: name,
              storeType: newStoreType,
              clientId: newStoreClientId,
            }
            update(storeinfo, true, true)
            onHandleClose()
          } else {
            onHandleClose()
          }
        }
      }
    )
  }

  handleTouchStart() {
    //users start touching other areas in the screen, remove the keyboard of mobile
    if (this.locationSearchInput && this.locationSearchInput.inputRef) {
      this.locationSearchInput.inputRef.blur()
    }
  }

  handleChange(event) {
    const { value } = event.target
    this.setState(
      {
        term: value,
        editing: true,
        type: '',
      },
      () => {
        if (typeof this.props.onSearchAddress === 'function') {
          this.props.onSearchAddress(value)
        }
      }
    )
  }

  async checkIfDeliverySupported(location) {
    try {
      const orderType = getUserType() === 'B2B' ? 'B2B' : 'DELIVERY'
      const queryString = Object.keys(location)
        .map(key => `${key}=${location[key]}`)
        .join('&')
      const apiUrl = `${API_URL}/serviceable-area?${queryString}&city=Singapore&availableStores=true&orderType=${orderType}`
      const response = await get(apiUrl)
      if (response.data && response.status === 'SUCCESS') {
        return {
          deliveryFee: response.data.deliveryFee,
          availableStores: response.data.availableStores,
          storeId: response.data.store.hasPicking
            ? response.data.store.id
            : response.data.store.pickingStoreId,
          storeName: response.data.store.name,
          storeType: response.data.store.storeType,
          pickingStoreId: response.data.store.pickingStoreId,
          clientId: response.data.store.clientId,
        }
      } else {
        return false
      }
    } catch (error) {
      this.setState({ error: error.message })
    }
  }

  async handleSetAddress(addressObj) {
    const deliveryAreaSupported = await this.checkIfDeliverySupported(
      {
        pincode: addressObj.postcode,
        latitude: addressObj.lat,
        longitude: addressObj.long,
      },
      this.props.bypassServiceabilityCheck
    )
    if (deliveryAreaSupported && deliveryAreaSupported.storeId) {
      this.setState({ loading: false, error: null }, () => {
        this.props.setLocation &&
          this.props.setLocation({
            pincode: addressObj.postcode,
            address: `${addressObj.buildingNumber ||
              ''}  ${addressObj.streetName ||
              ''}, Singapore  ${addressObj.postcode || ''}`,
            location: {
              latitude: addressObj.lat,
              longitude: addressObj.long,
            },
            latitude: addressObj.lat,
            longitude: addressObj.long,
            type: getUserType() === 'B2B' ? 'B2B' : 'delivery',
            storeId: deliveryAreaSupported.storeId,
            deliveryFee: deliveryAreaSupported.deliveryFee,
            storeName: deliveryAreaSupported.storeName,
            storeType: deliveryAreaSupported.storeType,
            availableStores: deliveryAreaSupported.availableStores,
            pickingStoreId: deliveryAreaSupported.pickingStoreId,
            building: addressObj.buildingName,
            clientId: deliveryAreaSupported.clientId,
          })
      })
    } else {
      this.setState({
        error: 'Sorry, this address is not serviceable. Contact Customer Service for assistance.',
        loading: false,
      })
    }
  }

  handleSetDeliveryAddress(address) {
    this.setState({
      type: getUserType() === 'B2B' ? 'B2B' : 'delivery',
      editing: false,
      error: '',
      term: `${address.buildingNumber || ''}  ${address.streetName ||
        ''}, Singapore  ${address.postcode || ''}`,
      isAddressSet: true,
      selectedAddress: address,
      currentLocation: {
        lat: address.lat,
        lng: address.long,
      },
    })
  }

  clearText() {
    this.setState({ term: '', editing: false, error: '', isAddressSet: false })
  }

  // To close checkout address popup
  handleClose() {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }

  fetchAddressNStore(term, isDonation) {
    const boysBrigadeEnaled =
      isDonation !== undefined
        ? isDonation
        : this.state.boysBrigadeValue?.enabled
    get(
      `${PUBLIC_API_URL}/address/search?type=all&term=${term}&service=cac&isBoysBrigade=${boysBrigadeEnaled}`
    ).then(response => {
      const suggestions = (response.data && response.data.addresses) || []
      const stores = (response.data && response.data.fpstores) || []
      this.setState({ suggestions, stores })
    })
  }

  fetchAddressNStorefromLatLng(location) {
    const boysBrigadeEnaled = this.state.boysBrigadeValue?.enabled
    get(
      `${PUBLIC_API_URL}/address/search?type=all&lat=${location.lat}&lng=${
        location.lng
      }&service=cac&isBoysBrigade=${boysBrigadeEnaled}`
    ).then(response => {
      const suggestions = (response.data && response.data.addresses) || []
      const stores = (response.data && response.data.fpstores) || []
      this.setState({ suggestions, stores, editing: true })
    })
  }

  async handleSelectSavedAddress(address) {
    const deliveryAreaSupported = await this.checkIfDeliverySupported(
      {
        pincode: address.pincode,
        latitude: address.latitude,
        longitude: address.longitude,
      },
      this.props.bypassServiceabilityCheck
    )
    if (deliveryAreaSupported && deliveryAreaSupported.storeId) {
      this.setState({ loading: false, error: null }, () => {
        let mainAddress = address.address
        const pincode = address.pincode
        const city = address.city
        if (mainAddress.search(pincode) === -1) {
          mainAddress = `${mainAddress}, ${city} ${pincode}`
        }
        this.props.setLocation &&
          this.props.setLocation({
            pincode: address.pincode && String(address.pincode),
            address: mainAddress,
            location: {
              latitude: address.latitude,
              longitude: address.longitude,
            },
            latitude: address.latitude,
            longitude: address.longitude,
            type: getUserType() === 'B2B' ? 'B2B' : 'delivery',
            availableStores: deliveryAreaSupported.availableStores,
            storeType: deliveryAreaSupported.storeType,
            storeId: deliveryAreaSupported.storeId,
            deliveryFee: deliveryAreaSupported.deliveryFee,
            storeName: deliveryAreaSupported.storeName,
            id: address.id,
            building: address.metaData && address.metaData.BuildingName,
            clientId: deliveryAreaSupported.clientId,
          })
      })
    } else {
      this.setState({
        error: 'Sorry, this address is not serviceable. Contact Customer Service for assistance.',
        loading: false,
      })
    }
  }

  handleGetCurrentLocation() {
    const succes = position => {
      const { latitude, longitude } = position.coords
      const boysBrigadeEnaled = this.state.boysBrigadeValue?.enabled
      get(
        `${PUBLIC_API_URL}/address/search?type=all&lat=${latitude}&lng=${longitude}&service=cac&isBoysBrigade=${boysBrigadeEnaled}`
      )
        .then(async response => {
          const suggestions = (response.data && response.data.addresses) || []
          if (!(suggestions && suggestions.length)) {
            this.setState({
              error: 'Unable to detect the location',
              loading: false,
            })
          } else {
            this.setState({
              suggestions,
              editing: false,
              loading: false,
              term: `${suggestions[0].buildingNumber || ''}  ${suggestions[0]
                .streetName || ''}, Singapore  ${suggestions[0].postcode ||
                ''}`,
              isAddressSet: true,
              type: getUserType() === 'B2B' ? 'B2B' : 'delivery',
              selectedAddress: suggestions[0],
              currentLocation: {
                lat: latitude,
                lng: longitude,
              },
            })
          }
        })
        .catch(() => {
          this.setState({
            error: 'Unable to detect the location',
            loading: false,
          })
        })
    }
    const error = res => {
      let message = 'Unexpected error occurred'
      if (res.code === 1) {
        message = 'Please allow location access'
      }
      this.setState({ error: message, loading: false })
    }
    if (navigator.geolocation) {
      this.setState({ loading: true })
      navigator.geolocation.getCurrentPosition(succes, error)
    } else {
      this.setState({ error: `Browser doesn't support Geolocation` })
    }
  }

  sendTrackingInfo(trackingLabel, isEventClick) {
    const event = {
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: isEventClick ? 'PopUp-Click' : 'PopUp',
      [GEV.EVENT_LABEL]: trackingLabel,
    }
    this.props.track(event)
  }

  componentWillUnmount() {
    if (this.props?.router?.asPath?.includes('/pcm')) {
      Router.push('/')
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.term !== this.state.term &&
      this.state.term &&
      this.state.term.trim().length > 2 &&
      !this.state.isAddressSet
    ) {
      this.fetchAddressNStore(this.state.term)
    }
    if (!deepEqual(prevProps.currentLocation, this.props.currentLocation)) {
      this.fetchAddressNStorefromLatLng(this.props.currentLocation)
    }
  }

  handleDonate() {
    const { boysBrigadeValue } = this.state
    this.setState(
      {
        term: boysBrigadeValue.prefilledText,
        editing: true,
        type: '',
      },
      () => {
        if (typeof this.props.onSearchAddress === 'function') {
          this.props.onSearchAddress(boysBrigadeValue.prefilledText)
        }
      }
    )
  }

  handleClickAndCollect() {
    const { clickAndCollectValue } = this.state
    this.setState(
      {
        term: clickAndCollectValue.prefilledText,
        editing: true,
        type: '',
      },
      () => {
        if (typeof this.props.onSearchAddress === 'function') {
          this.props.onSearchAddress(clickAndCollectValue.prefilledText)
        }
      }
    )
  }

  render() {
    const {
      term,
      addresses,
      error,
      type,
      loading,
      suggestions,
      editing,
      selectedAddress,
      clickAndCollectValue,
      boysBrigadeValue,
    } = this.state
    let {
      savedAddresses,
      isLoggedIn,
      popup,
    } = this.props
    if (
      editing &&
      term &&
      isLoggedIn &&
      savedAddresses &&
      savedAddresses.length
    ) {
      savedAddresses = savedAddresses
        .filter(add => addressSearch(add, term))
        .slice(0, 2)
    }
    return (
      <WrappperDiv data-testid="pcm" padEnable={!popup}>
        <TitleContent data-testid="pcm-title">
          <span>Enter your delivery</span>
          {clickAndCollectValue.enabled && <span>/collection</span>}
          <span> location</span>
        </TitleContent>

        <StyledLocationSearch data-testid="location-search">
          <InputGroup>
            <InputWrp>
              <Input
                autoFocus
                value={term}
                required
                data-testid="addressSearch"
                label="Address or postal code"
                clear={this.clearText}
                onChange={this.handleChange}
                ref={node => (this.locationSearchInput = node)}
                onFocus={this.handleFocus}
              />
            </InputWrp>
            <LocationText
              as="p"
              weight="bold"
              size="small"
              onClick={this.handleGetCurrentLocation}
            >
              Use my current location
            </LocationText>
            {clickAndCollectValue.enabled && getUserType() !== 'B2B' && (
              <HelpText
                data-testid="click-and-collect-helptext"
                onClick={this.handleClickAndCollect}
              >
                <BulbIcon
                  srcSet={`${BulbImg} 1x, ${BulbImg2X} 2x, ${BulbImg3X} 3x`}
                  src={`${BulbImg}`}
                />
                <Text as="p" size="medium">
                  {clickAndCollectValue.title}
                </Text>
                <ArrowWrap>
                  <i />
                </ArrowWrap>
              </HelpText>
            )}
            {boysBrigadeValue.enabled && (
              <HelpText
                onClick={this.handleDonate}
                data-testid="donate-helptext"
              >
                <BulbIcon
                  srcSet={`${BulbImg} 1x, ${BulbImg2X} 2x, ${BulbImg3X} 3x`}
                  src={`${BulbImg}`}
                />
                <Text as="p" size="medium">
                  {boysBrigadeValue.title}
                </Text>
                <ArrowWrap>
                  <i />
                </ArrowWrap>
              </HelpText>
            )}
          </InputGroup>
          {this.state.error && <ErrorText>{this.state.error}</ErrorText>}
          <Results onTouchStart={this.handleTouchStart}>
            {editing && (
              <div className="autocomplete-dropdown-container">
                {loading && <div className="suggestion-item">Loading...</div>}
                {savedAddresses &&
                  savedAddresses.map((address, index) => {
                    const phone = stripCountryCode(
                      address.metaData && address.metaData.Phone
                    )
                    return (
                      <AddressCard
                        data-testid="saved_address"
                        key={address.address + index}
                        onClick={() => this.handleSelectSavedAddress(address)}
                      >
                        <WrpText
                          size="medium"
                          color="#333333"
                          weight="bold"
                          margin="0 1rem 0 0"
                        >
                          {address.metaData && address.metaData.FirstName}
                        </WrpText>
                        <WrpText size="medium" color="#333333" weight="bold">
                          {phone}
                        </WrpText>
                        <div
                          css={`
                            display: flex;
                            flex-direction: column;
                          `}
                        >
                          {address.metaData &&
                            address.metaData.BuildingName && (
                              <Text>{`${address.metaData.BuildingName}`}</Text>
                            )}
                          <Text>
                            {address.address && (
                              <Text>{`${address.address}`}</Text>
                            )}
                            {address.metaData &&
                              (address.metaData.Floor ||
                                address.metaData.Unit) && (
                                <Text>
                                  {(address.metaData.Floor
                                    ? `, #${address.metaData.Floor}`
                                    : ', #floor') +
                                    ' ' +
                                    (address.metaData.Unit
                                      ? `- ${address.metaData.Unit}`
                                      : '- unit')}
                                </Text>
                              )}
                            {address.city && (
                              <Text>
                                {', ' + (address.city || 'Singapore')}
                              </Text>
                            )}
                            {address.pincode && (
                              <Text>{' ' + address.pincode}</Text>
                            )}
                          </Text>
                        </div>
                      </AddressCard>
                    )
                  })}
                {suggestions &&
                  suggestions.slice(0, 10).map((suggestion, index) => {
                    const className = suggestion.active
                      ? 'suggestion-item active'
                      : 'suggestion-item'
                    const firstLine =
                      suggestion.buildingName ||
                      (suggestion.buildingNumber || '') +
                        ' ' +
                        (suggestion.streetName || '')
                    const secondLine =
                      (suggestion.buildingNumber || '') +
                      ' ' +
                      (suggestion.streetName || '') +
                      ', ' +
                      'Singapore ' +
                      (suggestion.postcode || '')
                    return (
                      <div
                        key={index}
                        className={className}
                        data-testid="address-selection"
                        onClick={() =>
                          this.handleSetDeliveryAddress(suggestion)
                        }
                      >
                        <span className="main-text">{firstLine}</span>
                        <span className="secondary-text">{secondLine}</span>
                      </div>
                    )
                  })}
                {editing &&
                  term &&
                  !(
                    suggestions.length ||
                    (savedAddresses && savedAddresses.length)
                  ) && <NoResult>No result found</NoResult>}
              </div>
            )}
            {!this.props.hideViewMap && (
              <Fragment>
                {addresses &&
                  addresses.slice(0, 2).map((address, index) => (
                    <AddressCardWrp key={address.address + index}>
                      <AddressCard>
                        <CardTitle>
                          <WrpText
                            size="medium"
                            color="#333333"
                            weight="bold"
                            margin="0 1rem 0 0"
                          >
                            {address.metaData && address.metaData.FirstName}
                          </WrpText>
                          {index === 0 && <RadioSelectedIcon />}
                        </CardTitle>
                        <WrpText size="medium" color="#333333" weight="bold">
                          {address.metaData && address.metaData.Phone}
                        </WrpText>
                        <div>
                          <Text>{`${address.address}, ${address.city}, ${
                            address.pincode
                          }`}</Text>
                        </div>
                      </AddressCard>
                    </AddressCardWrp>
                  ))}
              </Fragment>
            )}
            {(type === 'delivery' || type === 'B2B') && !editing && !error && (
              <Button
                data-testid="address-selection-submit"
                onClick={() =>
                  this.handleSetAddress(
                    selectedAddress,
                    getUserType() === 'B2B' ? 'B2B' : 'delivery'
                  )
                }
              >
                <Text size="large" weight="bold" color="#ffffff">
                  {loading ? 'Checking...' : 'Select this location'}
                </Text>
              </Button>
            )}
          </Results>
        </StyledLocationSearch>
      </WrappperDiv>
    )
  }
}

const LocationSearchWrapper = props => (
  <GlobalContext.Consumer>
    {({ remoteConfig, organizationData }) => (
          <EventTrackingConsumer>
            {({ track }) => (
              <CheckoutAddressConsumer>
                {({ checkoutAddress, update }) => (
                  <LocationSearch
                    {...props}
                    track={track}
                    organizationData={organizationData}
                    remoteConfig={remoteConfig}
                    checkoutAddress={checkoutAddress}
                    update={update}
                  />
                )}
              </CheckoutAddressConsumer>
            )}
          </EventTrackingConsumer>
        )}
  </GlobalContext.Consumer>
)

export default withRouter(LocationSearchWrapper)